import { Link } from "react-router-dom";

const GOLD = "var(--altar-gold)";
const CHARCOAL = "var(--altar-charcoal)";
const MUTED = "var(--altar-muted)";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen font-altar p-3 sm:p-5 flex items-center justify-center" style={{ backgroundColor: "var(--altar-page)" }} data-testid="payment-cancel-page">
      <div className="w-full max-w-lg rounded-md p-1.5" style={{ border: `1.5px solid ${GOLD}` }}>
        <div className="rounded-sm px-8 py-14 text-center altar-fade" style={{ border: `0.5px solid ${GOLD}`, backgroundColor: "var(--altar-surface)" }}>
          <p className="text-3xl mb-6" style={{ color: "var(--altar-gold-soft)" }} aria-hidden="true">☾</p>
          <h1 className="font-square uppercase text-[22px] sm:text-[26px] leading-[1.4] tracking-[0.04em] mb-6" style={{ color: CHARCOAL, fontWeight: 500 }} data-testid="payment-cancel-title">
            Your gift was not completed
          </h1>
          <p className="italic text-lg mb-9 max-w-sm mx-auto" style={{ color: MUTED }}>
            No charge was made. The well remains open whenever your heart is ready.
          </p>
          <div className="flex flex-col items-center gap-3">
            <Link to="/well" data-testid="cancel-return-well" className="px-8 py-3 rounded-full text-base transition" style={{ backgroundColor: CHARCOAL, color: "var(--altar-surface)" }}>
              Return to the Well
            </Link>
            <Link to="/" data-testid="cancel-return-altar" className="text-sm underline" style={{ color: MUTED }}>
              Back to Inner Light
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
